import { useSnackbar } from "notistack";
import { validMobile } from "../../util/RegexValidation";
import { readFromLS, writeToLS } from "../../util/LocalStrogeService";
import axios from "axios";
import { useNavigate } from "react-router-dom";
import { rsToken, rsUserData, rsProgress } from "../../RecoilStates";
import { useRecoilState } from "recoil";

export function UseLogin() {
  const [progress, setProgress] = useRecoilState(rsProgress);
  const { enqueueSnackbar } = useSnackbar();
  const navigate = useNavigate();
  const [msToken, setMsToken] = useRecoilState(rsToken);
  const [msUserData, setMsUserData] = useRecoilState(rsUserData);

  function validate(loginState) {
    if (loginState.pass === "" || loginState.cell === "") {
      enqueueSnackbar("لطفا اطلاعات خود را وارد کنید", {
        variant: "error",
        autoHideDuration: 2000,
        preventDuplicate: true,
      });
      return 500;
    }
    return 200;
  }

  function getUserData(token, callback) {
    axios
      .get(`${window.ENV.url}Admin_users/0`, {
        headers: {
          token: token,
        },
      })
      .then((response) => {
        setProgress(false);
        if (response.data && response.data.state === 200) {
          writeToLS("ControllPanellUserData", response.data.resault[0]);
          setMsUserData(response.data.resault[0]);
          navigate("/");
        } else {
          enqueueSnackbar(response.data.message, {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
        }
      })
      .catch((error) => {
        setProgress(false);
        console.log(error);
      });
  }

  const doLogin = (loginState, callback) => {
    if (validate(loginState) != 200) {
      return;
    }
    axios
      .get(`${window.ENV.url}Admin_Login/${loginState.cell}/${loginState.pass}`)

      .then((response) => {
        callback(true);
        if (response.data && response.data.state === 200) {
          writeToLS("ControllPanellToken", response.data.resault);
          setMsToken(response.data.resault);
          getUserData(response.data.resault);
        } else {
          enqueueSnackbar(response.data.message, {
            variant: "error",
            autoHideDuration: 2000,
            preventDuplicate: true,
          });
        }
      })
      .catch((error) => {
        callback(true);
        setProgress(false);
        console.log(error);
      });
  };

  return {
    doLogin,
  };
}
